import { useState } from "react";
import { RelatorioFisicoFinanceiro } from "../../model/PrestacaoDeContas/RelatorioFisicoFinanceiro";
import Campo from "../Campo";
import styles from "./styles.module.css";
import CampoSelect from "../Campo/CampoSelect";
import CampoTextoLongo from "../Campo/CampoTextoLongo";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";

type Props = {
  refRelatorio?: RelatorioFisicoFinanceiro;
  closeModal: Function;
  list: RelatorioFisicoFinanceiro[];
  setList: React.Dispatch<React.SetStateAction<RelatorioFisicoFinanceiro[]>>;
  index?: number;
};

const ModalRelatorioFinanceiro = ({
  refRelatorio,
  closeModal,
  list,
  setList,
  index,
}: Props) => {
  const [etapa, setEtapa] = useState(refRelatorio?.etapa || 1);
  const [fase, setFase] = useState(refRelatorio?.fase || 1);
  const [unidadeMedida, setUnidadeMedida] = useState(
    refRelatorio?.unidade_medida || "unidade"
  );
  const [executado, setExecutado] = useState(refRelatorio?.executado || 1);
  const [programado, setProgramado] = useState(refRelatorio?.fase || 1);
  const [descricao, setDescricao] = useState(refRelatorio?.descricao || "");
  const [receitaConcedente, setReceitaConcedente] = useState(
    refRelatorio?.relatorio_financeiro.receita.concedente || 0
  );
  const [receitaExecutor, setReceitaExecutor] = useState(
    refRelatorio?.relatorio_financeiro.receita.executor || 0
  );
  const [receitaOutra, setReceitaOutra] = useState(
    refRelatorio?.relatorio_financeiro.receita.outra || 0
  );
  const [despesaConcedente, setDespesaConcedente] = useState(
    refRelatorio?.relatorio_financeiro.despesa.concedente || 0
  );
  const [despesaExecutor, setDespesaExecutor] = useState(
    refRelatorio?.relatorio_financeiro.despesa.executor || 0
  );
  const [despesaOutra, setDespesaOutra] = useState(
    refRelatorio?.relatorio_financeiro.despesa.outra || 0
  );
  const [despesaNatureza, setDespesaNatureza] = useState(
    refRelatorio?.relatorio_financeiro.despesa.naturezaDespesa || ""
  );

  return (
    <form className={styles.formModal}>
      <h2>Relatório fisico-financeiro</h2>
      <div className={styles.camposDados}>
        <div className={styles.gridCampos}>
          <Campo
            title="Etapa"
            type="number"
            maxLength={64}
            required={true}
            setter={setEtapa}
            value={etapa}
          />
          <Campo
            title="Fase"
            type="number"
            maxLength={64}
            required={true}
            setter={setFase}
            value={fase}
          />
        </div>
        <div className={styles.gridCampos}>
          <CampoSelect
            title="Unidade de medida"
            value={unidadeMedida}
            setter={setUnidadeMedida}
            required
          >
            <option value="unidade">unidade</option>
            <option value="par">par</option>
            <option value="dezena">dezena</option>
          </CampoSelect>
          <div className={styles.gridCampos}>
            <Campo
              title="Programado"
              type="number"
              placeholder="Digite a quantidade programada para o periodo"
              maxLength={64}
              required={true}
              customValidity="Preencha com a quantidade programada"
              setter={setProgramado}
              value={programado}
            />
            <Campo
              title="Executado"
              type="number"
              placeholder="Digite a quantidade executada no periodo"
              maxLength={64}
              required={true}
              customValidity="Preencha com a quantidade executada no periodo"
              setter={setExecutado}
              value={executado}
            />
          </div>
        </div>
        <CampoTextoLongo
          title="Descrição"
          setter={setDescricao}
          value={descricao}
          placeholder="Descrição"
        />
        <h3 className={styles.subTitulo}>
          Relatório financeiro - <strong>RECEITA</strong>
        </h3>
        <div className={styles.gridCampos}>
          <div className={styles.gridCampos}>
            <Campo
              title="Concedente"
              type="number"
              maxLength={64}
              required={true}
              setter={setReceitaConcedente}
              value={receitaConcedente}
            />
            <Campo
              title="Executor"
              type="number"
              maxLength={64}
              required={true}
              setter={setReceitaExecutor}
              value={receitaExecutor}
            />
          </div>
          <div className={styles.gridCampos}>
            <Campo
              title="Outra"
              type="number"
              maxLength={64}
              required={true}
              setter={setReceitaOutra}
              value={receitaOutra}
            />
          </div>
        </div>
        <hr className={styles.separador} />
        <h3 className={styles.subTitulo}>
          Relatório financeiro - <strong>DESPESA</strong>
        </h3>
        <div className={styles.gridCampos}>
          <div className={styles.gridCampos}>
            <Campo
              title="Concedente"
              type="number"
              maxLength={64}
              required={true}
              setter={setDespesaConcedente}
              value={despesaConcedente}
            />
            <Campo
              title="Executor"
              type="number"
              maxLength={64}
              required={true}
              setter={setDespesaExecutor}
              value={despesaExecutor}
            />
          </div>
          <div className={styles.gridCampos}>
            <Campo
              title="Outra"
              type="number"
              maxLength={64}
              required={true}
              setter={setDespesaOutra}
              value={despesaOutra}
            />
            <Campo
              title="Natureza"
              type="text"
              maxLength={64}
              required={true}
              setter={setDespesaNatureza}
              value={despesaNatureza}
            />
          </div>
        </div>
      </div>

      {!refRelatorio && (
        <input
          type="submit"
          value="+ Adicionar Relatório"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            const item: RelatorioFisicoFinanceiro = {
              etapa: etapa,
              fase: fase,
              descricao: descricao,
              executado: executado,
              programado: programado,
              unidade_medida: unidadeMedida,
              relatorio_financeiro: {
                receita: {
                  concedente: receitaConcedente,
                  executor: receitaExecutor,
                  outra: receitaOutra,
                },
                despesa: {
                  concedente: despesaConcedente,
                  executor: despesaExecutor,
                  outra: despesaOutra,
                  naturezaDespesa: despesaNatureza,
                },
              },
            };

            addList({
              item,
              list,
              setList,
            });
            closeModal();
          }}
        />
      )}
      {refRelatorio !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Relatório"
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              const item: RelatorioFisicoFinanceiro = {
                etapa: etapa,
                fase: fase,
                descricao: descricao,
                executado: executado,
                programado: programado,
                unidade_medida: unidadeMedida,
                relatorio_financeiro: {
                  receita: {
                    concedente: receitaConcedente,
                    executor: receitaExecutor,
                    outra: receitaOutra,
                  },
                  despesa: {
                    concedente: despesaConcedente,
                    executor: despesaExecutor,
                    outra: despesaOutra,
                    naturezaDespesa: despesaNatureza,
                  },
                },
              };
              editList({
                item,
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalRelatorioFinanceiro;
